import { render, staticRenderFns } from "./SchedaUtente.vue?vue&type=template&id=3c72ce04&"
import script from "./SchedaUtente.vue?vue&type=script&lang=js&"
export * from "./SchedaUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports